import { C } from '../constants';

export default function IndustryContext({ bullets }) {
  if (!bullets?.length) return null;
  return (
    <div style={{ marginBottom:16 }}>
      <div className="hma-section-label">Industry Landscape</div>
      <div style={{ background:C.card2, border:`1px solid ${C.bord}`, borderRadius:16, overflow:"hidden" }}>
      <div style={{ padding:"12px 18px", display:"flex", flexDirection:"column", gap:10 }}>
        {bullets.map((item,i) => {
          const text = typeof item === "string" ? item
            : (item.bullet || item.text || item.description || item.point || item.insight || item.content || item.detail || "");
          if (!text) return null;
          const rs = typeof item === "object" ? (item.sentiment||item.impact||item.tone||"neutral").toString().toLowerCase() : "neutral";
          const sent = rs.includes("pos")||rs.includes("bull") ? "positive" : rs.includes("neg")||rs.includes("bear") ? "negative" : "neutral";
          const dotColor = sent==="positive"?C.green:sent==="negative"?C.neg:C.gold2;
          const bg       = sent==="positive"?"rgba(0,200,5,0.06)":sent==="negative"?"rgba(255,59,48,0.06)":"rgba(201,168,76,0.06)";
          const border   = sent==="positive"?"rgba(0,200,5,0.15)":sent==="negative"?"rgba(255,59,48,0.15)":"rgba(201,168,76,0.15)";
          return (
            <div key={i} style={{ display:"flex", gap:12, alignItems:"flex-start", background:bg, border:`1px solid ${border}`, borderRadius:12, padding:"12px 14px" }}>
              <div style={{ width:8, height:8, borderRadius:"50%", background:dotColor, flexShrink:0, marginTop:4 }}/>
              <div style={{ fontSize:13, color:C.text, lineHeight:1.6, fontWeight:500 }}>{text}</div>
            </div>
          );
        })}
      </div>
      </div>
    </div>
  );
}
